module.exports = __webpack_public_path__ + "static/media/anterghat.6ca655c8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/anterghat.jpeg
// module id = 535
// module chunks = 0